import React, { useCallback, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import moment from 'moment';
import DatePickerSmall from '../components/datePicker';

const CustomDate = ({
    updateCardmutate,
    value,
    disabled
}) => {
    const [open, setOpen] = useState(false);

    const handleDueDateKeyDown = (newDate) => {
        updateCardmutate(newDate ? moment(newDate).format("YYYY-MM-DD") : 0);
        setOpen(false);
    };

    const handleDuedateBlur = () => {
        setOpen(false);
    };

    const handleDueDate = useCallback(() => {
        if (!disabled) {
            setOpen(true);
        }
    }, [disabled]);

    return (
        <div className="custom-date-container">
            {open ? (
                <DatePickerSmall
                    date={value}
                    handleDueDateKeyDown={handleDueDateKeyDown}
                    handleDuedateBlur={handleDuedateBlur}
                    disabled={disabled}
                />
            ) : (
                <div className="due-date" onClick={handleDueDate}>
                    <div className="due-date-input">
                        {value ? (
                            moment.utc(value).local().format("MM/DD/YYYY")
                        ) : (
                            <p className="due-date-input-none">None</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomDate;